import React from "react";

export default function NoPage() {
  return (
    <div className="h-screen w-full flex justify-center bg-secondary">
      <img
        src="https://static-00.iconduck.com/assets.00/9-404-error-illustration-2048x908-vp03fkyu.png"
        alt="404"
        className="w-[50%] object-contain"
      />
    </div>
  );
}
